import DSSLogo from 'assets/images/dss-logo.svg';
import MCLogo from 'assets/images/mastercard-logo.svg';

const FooterConfig = {
  PAYMENT_IMAGES: [
    { src: DSSLogo, width: 50, height: 20, alt: 'dss-logo' },
    { src: MCLogo, width: 45, height: 20, alt: 'visa-logo' },
  ],
  SUPPORT_EMAIL: ['ozk@kassa24.kz', 'dispute@kassa24.kz'],
  SUPPORT_PHONE: '+77020750601',
};

export { FooterConfig };
